import { render, staticRenderFns } from "./nav-footer.vue?vue&type=template&id=dfb2f308&scoped=true&"
import script from "./nav-footer.vue?vue&type=script&lang=js&"
export * from "./nav-footer.vue?vue&type=script&lang=js&"
import style0 from "./nav-footer.vue?vue&type=style&index=0&id=dfb2f308&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dfb2f308",
  null
  
)

export default component.exports